import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { conversations as conversationsAPI } from '../../services/api';
import './ConversationPage.css';

const ConversationPage = () => {
  const [conversations, setConversations] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    loadConversations();
  }, []);

  const loadConversations = async () => {
    try {
      const response = await conversationsAPI.getAll();
      setConversations(response.data);
    } catch (error) {
      console.error('Failed to load conversations:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCreateConversation = async () => {
    try {
      const response = await conversationsAPI.create({
        language: 'es',
        region: 'MX',
      });
      navigate(`/conversation/${response.data.id}`);
    } catch (error) {
      console.error('Failed to create conversation:', error);
    }
  };

  if (loading) {
    return (
      <div className="page-container">
        <div className="loading">Loading conversations...</div>
      </div>
    );
  }

  return (
    <div className="page-container">
      <header className="page-header">
        <button className="btn-back" onClick={() => navigate('/home')}>
          ← Back
        </button>
        <h1>Conversations</h1>
      </header>

      <main className="page-content">
        <button className="btn-create" onClick={handleCreateConversation}>
          + Start New Conversation
        </button>

        <div className="conversations-list">
          {conversations.length === 0 ? (
            <div className="empty-state">
              <p>No conversations yet</p>
              <p className="subtitle">Start your first conversation to practice!</p>
            </div>
          ) : (
            conversations.map((conv) => (
              <div
                key={conv.id}
                className="conversation-item"
                onClick={() => navigate(`/conversation/${conv.id}`)}
              >
                <div className="conversation-icon">💬</div>
                <div className="conversation-info">
                  <h3>{conv.language} - {conv.region}</h3>
                  <p>{conv.messageCount || 0} messages</p>
                  <p className="timestamp">
                    {new Date(conv.createdAt).toLocaleDateString()}
                  </p>
                </div>
              </div>
            ))
          )}
        </div>
      </main>
    </div>
  );
};

export default ConversationPage;
